export default __webpack_public_path__ + "static/media/calmcarminelizard2draft_926e57134e638aec4386c140b11ae62b.f2c83ff6.png";